import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ReservationChannels } from 'src/app/features/restaurants/models/List.Restaurant';
import { RestaurantService } from 'src/app/features/restaurants/services/Restaurant.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import Swal from 'sweetalert2';

export interface DialogData {
  restaurantId: number
}

@Component({
  selector: 'app-reservation-channels',
  templateUrl: './reservation-channels.component.html'
})
export class ReservationChannelsComponent extends DirtyComponent implements OnInit {

  dataLoading = false;
  loading = false;
  isSubmitted = false;
  isOnlineRes = false;
  reservationChannels: any = []
  reservationChannelsCopy: any = []

  otherValue = new FormControl([]);
  constructor(
    private service: RestaurantService,
    override dialogRef: MatDialogRef<ReservationChannelsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    translate: TranslateService, private formBuilder: FormBuilder
  ) {
    super(translate)
  }

  ngOnInit(): void {
    this.GetReservationChannels();

    this.buildForm();
  }


  buildForm() {
    this.formGroup = this.formBuilder.group({
      otherValue: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(50),
        Validators.required
      ]],
    })
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
  override canDeactivate(): boolean {
    return JSON.stringify(this.reservationChannels).length !== this.reservationChannelsCopy.length;
  };

  GetReservationChannels() {
    this.dataLoading = true;
    this.service.GetReservationChannels(this.data.restaurantId).subscribe((data: any) => {
      this.dataLoading = false;
      this.reservationChannels = data.allReservationChannels;
      this.reservationChannelsCopy = JSON.stringify(this.reservationChannels);
    })
  }

  isOnline() {
    this.isOnlineRes = !this.isOnlineRes
    this.otherValue.clearValidators()
  }

  validateReservationLength() {
    if (this.reservationChannels.filter((item: any) => !item.isOnlineReservation && item.isSelected)?.length > 0) {
      return true
    } else {
      return false
    }
  }

  validateIsOtherValue() {
    if (this.reservationChannels.some((item: any) => !item.isOnlineReservation && item.isOther && item.isSelected)) {
      return true;
    } else {
      return false;
    }
  }

  saveRecord() {
    this.isSubmitted = true;
    let reservationChannels =
      this.reservationChannels.filter((item: any) => item.isSelected).map((x: any) => {
        return {
          id: x.id,
          otherValue: (x.isOther ? x.otherValue : '')
        }
      })
    if ((!this.validateIsOtherValue() || this.otherValue.value) && this.validateReservationLength()) {
      this.loading = true;
      let data = {
        reservationChannels,
        restaurantId: this.data.restaurantId,
      };

      this.service.EditReservationChannels(data).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.translate.instant('swalMsg.updatedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true);
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    } else {
      let msg;
      if (!this.validateReservationLength()) {
        msg = this.translate.instant('swalMsg.youShouldChooseAtLeastOneSelection')
      } else {
        msg = this.translate.instant('swalMsg.pleaseFillTheRequiredFields')
      }
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: msg,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      });
    }

  }

}
